export const BusinessTypes = {
  STORE: 1,
  RENTAL: 2,
}

export const BUSINESS_TYPE_OPTIONS = [
  { id: BusinessTypes.STORE, name: 'Магазин', help: 'Продажа физических или цифровых товаров.' },
  { id: BusinessTypes.RENTAL, name: 'Аренда', help: 'Временное использование имуществом за деньги.' },
]

export function businessTypeById(typeId) {
  const id = Number(typeId) === BusinessTypes.RENTAL ? BusinessTypes.RENTAL : BusinessTypes.STORE
  return BUSINESS_TYPE_OPTIONS.find((option) => option.id === id)
}
